import { useSelector } from 'react-redux';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { editFolderSchema, editFileSchema } from 'validation/form/file';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormTextField } from 'components/common/form/Form';
import { useEffect } from 'react';
import { useFileDrawers } from 'hooks/useFileDrawers';
import { useFile } from 'hooks/useFile';
import { EntityFileDetails } from 'components/shared/EntityFileDetails';

export const RenameFile = (props) => {
  const { close } = props;

  const fileFormLoading = useSelector((state) => state.files.fileForm.loading);
  const { openDrawerFileDetails } = useFileDrawers();
  const { handleRenameFile } = useFile();

  const selectedFile = useSelector((state) => state.files.selectedFile);
  const type = selectedFile.fileType === 'Folder' ? 'Folder' : 'File';
  const schema = selectedFile.fileType === 'Folder' ? editFolderSchema : editFileSchema;

  const methods = useForm({ resolver: yupResolver(schema), defaultValues: selectedFile });

  const handleSave = methods.handleSubmit((data) => {
    handleRenameFile(data.oid, data.name, data.format, close);
  });

  const handleCancel = () => {
    openDrawerFileDetails();
  };

  useEffect(() => {
    methods.reset(selectedFile);
  }, [methods, selectedFile]);

  return (
    <DrawerContent>
      <DrawerContent.Header title={selectedFile?.id ? `Rename ${selectedFile?.name}` : ''} />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          {!selectedFile?.id && <EntityFileDetails.EmptyFile />}
          {selectedFile?.id && (
            <FormProvider {...methods}>
              <FormTextField
                name="name"
                label={`${type} Name`}
                control={methods.control}
              />
            </FormProvider>
          )}
        </DrawerContent.Content>
        {selectedFile?.id && (
          <DrawerContent.ActionButtons
            submitButtonText="Save"
            submitButtonLoading={fileFormLoading}
            submit={handleSave}
            close={handleCancel}
          />
        )}
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
